var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _rect10, _rect11, _rect12, _rect13, _circle2, _circle3, _rect14, _rect15, _rect16, _circle4, _rect17, _circle5, _rect18, _rect19, _rect20, _rect21, _circle6, _rect22, _rect23, _rect24, _circle7, _rect25, _circle8, _circle9, _rect26, _rect27, _rect28, _rect29, _circle10, _rect30, _rect31, _rect32, _rect33, _circle11, _rect34, _rect35, _rect36, _circle12, _rect37, _circle13, _circle14, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen03List(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 110,
    height: 16,
    rx: 8,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 104,
    width: 320,
    height: 44,
    rx: 22,
    fill: "#141d27",
    opacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 126,
    r: 8,
    fill: "#4b5a68",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 122,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#4b5a68",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 162,
    width: 78,
    height: 30,
    rx: 15,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 162,
    width: 78,
    height: 30,
    rx: 15,
    fill: "#1a2531",
    opacity: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 162,
    width: 78,
    height: 30,
    rx: 15,
    fill: "#1a2531",
    opacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 236,
    r: 22,
    fill: "#2c7f86",
    opacity: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 232,
    r: 8,
    fill: "#5ce1e6",
    opacity: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 224,
    width: 139,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 242,
    width: 96,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 224,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 246,
    r: 7,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 272,
    width: 258,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 306,
    r: 22,
    fill: "#1a2531",
    opacity: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 294,
    width: 156,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 312,
    width: 145,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 294,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 342,
    width: 258,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 376,
    r: 22,
    fill: "#1a2531",
    opacity: 1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 364,
    width: 121,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 382,
    width: 89,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 364,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 386,
    r: 7,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 412,
    width: 258,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 446,
    r: 22,
    fill: "#2c7f86",
    opacity: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 442,
    r: 8,
    fill: "#5ce1e6",
    opacity: 0.8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 434,
    width: 169,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 452,
    width: 104,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 434,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 482,
    width: 258,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 516,
    r: 22,
    fill: "#1a2531",
    opacity: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 504,
    width: 114,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 522,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 504,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 552,
    width: 258,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 586,
    r: 22,
    fill: "#1a2531",
    opacity: 1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 574,
    width: 118,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 592,
    width: 108,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 574,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 596,
    r: 7,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 622,
    width: 258,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 656,
    r: 22,
    fill: "#2c7f86",
    opacity: 1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 652,
    r: 8,
    fill: "#5ce1e6",
    opacity: 0.8
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 644,
    width: 167,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 662,
    width: 123,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 644,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 692,
    width: 258,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 696,
    width: 360,
    height: 84,
    rx: 0,
    fill: "#141d27",
    opacity: 1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen03List);
export default __webpack_public_path__ + "static/media/screen-03-list.bef96f75262201bc3b274902246713b6.svg";
export { ForwardRef as ReactComponent };